import { useProfileTranslations } from "@/hooks/use-profile-translations";
import { useState } from "react";
import { IoIosLock } from "react-icons/io";
import { HoneypotUnlock } from "./honeypot-unlock";

export function Honeypot() {
  const [username, setUsername] = useState("");
  const [searched, setSearch] = useState(false);

  const { tProfile, tCommon } = useProfileTranslations("enterProfileUsername");

  const handleSearch = () => {
    if (!username.trim()) return;
    setSearch(true);
  };

  if (searched) {
    return <HoneypotUnlock />;
  }

  return (
    <div className="px-6 py-4">
      <div className="flex flex-col items-center">
        <h1 className="text-xl font-semibold mb-1 text-center">
          {tCommon("title")}
        </h1>

        <div className="border-t w-full my-3 border-neutral-800"></div>

        <p className="text-sm mb-4 w-full text-center font-medium">
          {tProfile("subtitle")}
        </p>

        <div className="w-full space-y-4">
          <div className="w-full relative">
            <div className="absolute inset-y-0 left-0 flex items-center pl-4 text-lg text-[#FF6B00]">
              @
            </div>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value.toLowerCase().trim())}
              className={`w-full h-12 pl-10 pr-4 border border-neutral-800 rounded-lg focus:outline-none focus:border-[#FF6B00]`}
              placeholder={tProfile("placeholder")}
            />
          </div>

          <div className="flex items-center justify-center gap-2 text-xs text-gray-400">
            <IoIosLock />
            <span>{tCommon("securityMessage")}</span>
          </div>

          <button
            onClick={handleSearch}
            className={`w-full mt-4 py-3 rounded-lg ${
              !username.trim()
                ? "bg-neutral-700 text-neutral-400 cursor-not-allowed"
                : "bg-[#FF6B00] text-white"
            }`}
            disabled={!username.trim()}
          >
            {tCommon("buttonText")}
          </button>
        </div>
      </div>
    </div>
  );
}
